import semver from 'semver';

export const hasAnUpdateAvailable = (latestVersion, currentVersion) => {
  return false;
  if (!semver.valid(latestVersion)) {
    return false;
  }
  return semver.lt(currentVersion, latestVersion);
};
